export default __webpack_public_path__ + "static/media/cnha-logo.f569e83e.png";